module.exports = __webpack_public_path__ + "fonts/Manrope-600-latin18_e85a026.woff2";